export default __webpack_public_path__ + "static/media/userdetails-icon.53d57460.svg";